import { Box } from '@ouster/webviz-react-components';

export default function RecordingDistribution() {
  return (
    <Box
      display="flex"
      placeItems="center"
      justifyContent="center"
      h="full"
      fontSize="2xl"
    >
      Recording Distribution (coming soon...)
    </Box>
  );
}
